import { render, staticRenderFns } from "./hobbies-bubble13.vue?vue&type=template&id=c0d08294&"
import script from "./hobbies-bubble13.vue?vue&type=script&lang=js&"
export * from "./hobbies-bubble13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports